import {
  CreateCheckoutResponse,
  GetCouponResponse,
} from '../py-generated/datalouder/checkout/types';
import { GetMembershipDetailsResponse } from '../py-generated/datalouder/membership/types';
import { apiUrl, apiv2Url } from './config';
import {
  getOption,
  getPromise,
  postOptionWithBody,
  postPromise,
  RequestOptions,
} from './utils';

const add = (
  amount: number,
  note: string,
  method: string,
  reference: string,
  promo?: string
): Promise<any> =>
  postPromise(`${apiUrl}/transaction/add`, {
    amount,
    note,
    method,
    reference,
    promo,
  });

const getPrices = (): Promise<any> =>
  getPromise(`${apiUrl}/transaction/prices`, {});

const getCoupon = (
  code: string,
  isSandbox: boolean
): Promise<GetCouponResponse> =>
  getPromise(`${apiv2Url}/coupon`, { promo: code, isSandbox });

const getMembershipDetails = (): Promise<GetMembershipDetailsResponse> =>
  getPromise(`${apiv2Url}/membership/details`, {});

const getSubscriptionDetailOptions = (): RequestOptions => {
  return {
    url: `${apiUrl}/transaction/subscriptionDetail`,
    ...getOption(),
  };
};

const cancelPaypalSubscriptionOptions = (
  subscriptionId: string
): RequestOptions => {
  return {
    url: `${apiUrl}/transaction/cancelPaypalSubscription`,
    ...postOptionWithBody({ subscriptionId }),
  };
};

const cancelSubscriptionOptions = (
  provider: string,
  subscriptionId: string
): RequestOptions => {
  return {
    url: `${apiv2Url}/membership/subscription/cancel`,
    ...postOptionWithBody({ provider, subscriptionId }),
  };
};

const freeTrialAvailable = (): Promise<{ freeTrialAvailable: boolean }> =>
  getPromise(`${apiv2Url}/membership/free-trial-available`, {});

const createStripeSession = (
  priceId: string,
  hasTrial: boolean,
  isSandbox: boolean,
  promo?: string,
  isStripeNativePromo?: boolean,
  oneTimePayment?: boolean,
  switchFromManual?: boolean,
  metadata?: Record<string, string>
): Promise<CreateCheckoutResponse> =>
  postPromise(`${apiv2Url}/stripe/checkout`, {
    priceId,
    hasTrial,
    promo,
    isSandbox,
    stripePromo: isStripeNativePromo,
    oneTimePayment,
    switchFromManual,
    metadata,
  });

export default {
  add,
  getPrices,
  getCoupon,
  getSubscriptionDetailOptions,
  cancelSubscriptionOptions,
  cancelPaypalSubscriptionOptions,
  freeTrialAvailable,
  createStripeSession,
  getMembershipDetails,
};
